if (typeof window !== 'undefined' && window.SwiperElementRegisterParams) {
    window.SwiperElementRegisterParams(['linesEffect']);
}

export default function EffectLines({ swiper, extendParams, on, emit }) {
    extendParams({
        linesEffect: {
            split: 5,
            width: null,
            snap: [],
        },
    });

    function effectVirtualTransitionEnd({ duration }) {
        const { slides, activeIndex } = swiper;
        if (duration !== 0) {
            let eventTriggered = false;
            if (!slides[activeIndex]) return;
            const transitionEndTarget = slides[activeIndex].querySelector('.swiper-lines-inner:nth-child(1)');
            if (!transitionEndTarget) return;
            const onTransitionEnd = (e) => {
                if (e.target !== transitionEndTarget) return;
                transitionEndTarget.removeEventListener('transitionend', onTransitionEnd);
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;

                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true,
                });
                swiper.wrapperEl.dispatchEvent(evt);
            };
            transitionEndTarget.addEventListener('transitionend', onTransitionEnd);
        }
    }

    /**
     * Create images clones
     *
     * Takes every slide and creates clones of the image element
     * as many as specified in the `linesEffect.split` parameter
     */
    const createImages = () => {
        swiper.slides.forEach((slideEl) => {
            if (slideEl.querySelector('.swiper-lines-image-clones')) return;
            const imageEl = slideEl.querySelector('.swiper-lines-image');
            if (!imageEl) return;
            const nextEl = imageEl.nextElementSibling;
            const cloneContainerEl = document.createElement('div');
            cloneContainerEl.classList.add('swiper-lines-image-clones');
            for (let i = 0; i < swiper.params.linesEffect.split; i += 1) {
                const div = document.createElement('div');
                div.classList.add('swiper-lines-image-clone');
                const inner = document.createElement('div');
                inner.classList.add('swiper-lines-inner');
                div.appendChild(inner);
                inner.appendChild(imageEl.cloneNode());
                cloneContainerEl.appendChild(div);
            }
            if (nextEl) {
                imageEl.parentNode.insertBefore(cloneContainerEl, nextEl);
            } else {
                imageEl.parentNode.appendChild(cloneContainerEl);
            }
        });
    };

    /**
     * Set images styles
     *
     * Set the width and height of the image clones
     */
    const setImages = () => {
        const snapPositions = [];
        let wholeWidth = 0;

        if (swiper.params.linesEffect.snap && swiper.params.linesEffect.snap.length > 0) {
            swiper.params.linesEffect.snap.forEach((snapEl) => {
                const snap = document.querySelector(snapEl);
                if (snap) {
                    // Get position of the snap element relative to the swiper wrapper
                    const position = snap.getBoundingClientRect().left - swiper.wrapperEl.getBoundingClientRect().left;
                    snapPositions.push(position);
                }
            });

            wholeWidth = document.querySelector('.swiper-wrapper').offsetWidth;

            // How much percentage does each snap take up
            swiper.params.linesEffect.widths = snapPositions.map((position, index) => {
                if (index === 0) {
                    return (position / wholeWidth) * 100;
                }
                return ((position - snapPositions[index - 1]) / wholeWidth) * 100;
            });

            swiper.params.linesEffect.split = snapPositions.length;
        }

        swiper.slides.forEach((slideEl) =>
            slideEl.querySelectorAll('.swiper-lines-image').forEach((imageEl) => {
                imageEl.style.width = `${swiper.width}px`;
                imageEl.style.height = `${swiper.height}px`;
            }),
        );
        swiper.slides.forEach((slideEl) => {
            slideEl.querySelectorAll('.swiper-lines-image-clone').forEach((cloneEl, cloneElIndex) => {
                const cloneImg = cloneEl.querySelector('.swiper-lines-image');
                const portion =
                    swiper.params.linesEffect.widths && swiper.params.linesEffect.widths[cloneElIndex]
                        ? swiper.params.linesEffect.widths[cloneElIndex]
                        : 100 / swiper.params.linesEffect.split;
                let position = (100 / swiper.params.linesEffect.split) * cloneElIndex;

                if (swiper.params.linesEffect.widths && swiper.params.linesEffect.widths !== null) {
                    position = swiper.params.linesEffect.widths
                        .slice(0, cloneElIndex)
                        .reduce((acc, width) => acc + width, 0);
                }

                let imageOffset = `${-100 * cloneElIndex}%`;

                if (
                    swiper.params.linesEffect.widths &&
                    swiper.params.linesEffect.widths !== null &&
                    swiper.params.direction === 'horizontal'
                ) {
                    imageOffset = 0;
                    for (let i = 0; i < cloneElIndex; i += 1) {
                        imageOffset -= swiper.width * (swiper.params.linesEffect.widths[i] / 100);
                    }
                    imageOffset = `${imageOffset}px`;
                } else if (
                    swiper.params.linesEffect.widths &&
                    swiper.params.linesEffect.widths !== null &&
                    swiper.params.direction === 'vertical'
                ) {
                    imageOffset = 0;
                    for (let i = 0; i < cloneElIndex; i += 1) {
                        imageOffset -= swiper.height * (swiper.params.linesEffect.widths[i] / 100);
                    }
                    imageOffset = `${imageOffset}px`;
                }

                if (swiper.params.direction === 'vertical') {
                    cloneEl.style.height = `${portion}%`;
                    cloneEl.style.top = `${position}%`;
                    cloneImg.style.top = `${imageOffset}`;
                } else {
                    cloneEl.style.width = `${portion}%`;
                    cloneEl.style.left = `${position}%`;
                    cloneImg.style.left = `${imageOffset}`;
                }
            });
        });
    };

    /**
     * Set translate
     *
     * Set the translate of the slides and the image clones
     */
    const setTranslate = () => {
        const axis = swiper.params.direction === 'vertical' ? 'Y' : 'X';

        const { slides } = swiper;

        slides.forEach((slideEl, slideIndex) => {
            const offset = slideEl.swiperSlideOffset;
            slideEl.style.transform = `translate${axis}(-${slideIndex * 100}%)`;

            const { progress } = slideEl;

            if (swiper.isBeginning && swiper.swipeDirection === 'prev' && progress < 0 && progress > -1) {
                return;
            }

            if (swiper.isEnd && swiper.swipeDirection === 'next' && progress > 0 && progress < 1) {
                return;
            }

            const tX = axis === 'X' ? -offset : 0;
            const tY = axis === 'X' ? 0 : -offset;
            const tZ = 0;
            const rotate = 0;

            const transform = `
          translate3d(${tX}px, ${tY}px, ${tZ}px)
          rotateZ(${rotate}deg)
        `;

            slideEl.style.transform = transform;

            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

            const contentEl = slideEl.querySelector('.swiper-slide-content');
            if (contentEl) {
                contentEl.style.transform = `translate${axis}(${swiper.size * -progress * 1.2}px)`;
            }

            const images = slideEl.querySelectorAll('.swiper-lines-inner');
            images.forEach((imageEl) => {
                const manipulation = progress * 100;
                imageEl.style.transform = `translate${axis}(${manipulation}%)`;
            });
        });
    };

    const setTransition = (duration) => {
        swiper.slides.forEach((slideEl) => {
            const images = slideEl.querySelectorAll('.swiper-lines-inner');
            const contentEl = slideEl.querySelector('.swiper-slide-content');
            if (contentEl) {
                contentEl.style.transitionDuration = `${duration}ms`;
            }
            // eslint-disable-next-line

            images.forEach((imageEl, imageIndex) => {
                if (duration === 0) {
                    imageEl.style.transitionTimingFunction = 'ease-out';
                    imageEl.style.transitionDuration = `${
                        swiper.params.speed +
                        (swiper.params.speed / (images.length - 1)) * (images.length - imageIndex - 1)
                    }ms`;
                } else {
                    imageEl.style.transitionTimingFunction = '';
                    imageEl.style.transitionDuration = `${
                        duration + (duration / (images.length - 1)) * (images.length - imageIndex - 1)
                    }ms`;
                }
            });
        });

        effectVirtualTransitionEnd({ duration });
    };

    on('setTranslate', () => {
        if (swiper.params.effect !== 'lines') return;

        setTranslate();
    });

    on('setTransition', (_s, duration) => {
        if (swiper.params.effect !== 'lines') return;

        setTransition(duration);
    });

    on('slidesLengthChange', () => {
        createImages();
        setImages();
    });

    on('beforeInit', () => {
        if (swiper.params.effect !== 'lines') return;

        swiper.classNames.push('swiper-lines');

        const overwriteParams = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true,
        };

        Object.assign(swiper.params, overwriteParams);
        Object.assign(swiper.originalParams, overwriteParams);
    });
    on('init', () => {
        if (swiper.params.effect !== 'lines') return;

        createImages();
        emit('setTranslate', swiper, swiper.translate);
    });

    on('resize init', () => {
        if (swiper.params.effect !== 'lines') return;

        setImages();
    });
}
